import styled from 'styled-components';

import { getThemeProps } from 'ravenjs/utils/theme';

import { ELEMENT_IDS } from 'constants/elements';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

/*
 * Opt-in class for pages that are designed to work below the 1280px desktop
 * baseline. Adding it lets the shell shrink to the viewport instead of forcing
 * the 1200px floor, which otherwise pushes the whole page into a horizontal
 * scroll on tablet / small laptop widths. Pages opt in via `useFluidAppWidth`.
 */
export const FLUID_WIDTH_CLASS = 'appWrapperFluidWidth';

const AppWrapperStyled = styled.div.attrs(() => ({
    id: ELEMENT_IDS.AppWrapper,
}))`
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    z-index: 0;

    ${({ theme }) => theme.media.up('md')`
        // As the minimum supported desktop width is 1280px 
        // and considering some space for vertical scrollbar. 
        min-width: 1200px;
    `};
    ${({ theme }) => theme.media.down('md')`
        min-width: 100%;
    `};

    &.${FLUID_WIDTH_CLASS} {
        ${({ theme }) => theme.media.up('md')`
            min-width: 100%;
        `};

        /*
         * The fixed 100% height makes the flex children shrink instead of laying
         * out below each other, so on a page taller than the viewport the footer
         * is pulled up over the end of the content. Growing with the content and
         * only filling the viewport as a minimum keeps the footer right after it.
         */
        height: auto;
        min-height: 100%;
    }

    * > ::-webkit-scrollbar {
        width: 0.625rem;
    }
    * > ::-webkit-scrollbar:horizontal {
        height: 0.375rem;
    }
    * > ::-webkit-scrollbar-track-piece {
        background-color: ${MIGRATED_COLORS.lightest};
    }
    * > ::-webkit-scrollbar-thumb:horizontal {
        background-color: ${({ theme }) =>
            getThemeProps('palette.primary.gradientColor', MIGRATED_COLORS.lightblue, { theme })};
    }
    * > ::-webkit-scrollbar-thumb:vertical {
        background-color: ${({ theme }) =>
            getThemeProps('palette.primary.gradientColor', MIGRATED_COLORS.lightblue, { theme })};
    }

    ${getThemeProps('AppWrapper.styles')};
`;

export default AppWrapperStyled;
